import { Box } from "@chakra-ui/react";
import { EstiloConsultaPrevia } from "store/modules/consultaprevia/types";

/**
 * Amostra da cor com que a camada aparece no mapa. É o que liga a ficha à
 * mancha: sem ela o cidadão lê o nome da zona e não sabe qual desenho é.
 */
export const SwatchCamada = ({
  estilo,
  size = 4
}: {
  estilo?: EstiloConsultaPrevia | null;
  size?: number;
}) => {
  if (!estilo) return null;

  return (
    <Box
      flexShrink={0}
      h={size}
      w={size}
      borderRadius="sm"
      bgColor={estilo.corPreenchimento}
      border="2px solid"
      borderColor={estilo.corBorda}
    />
  );
};
